import React from 'react'
import DarkMessageIcom from '../../../../media/felsv/dark_message_icon.svg'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {useDispatch} from 'react-redux'
import {gu_cu_ShowModalConfirmacion} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {bindActionCreators} from 'redux'
import {actionsGUCreacionUsuario} from '../../../../actions/action-creators'

const ModalConfirmacionContacto = () => {
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)

  const cancelar = async () => await dispatch(gu_cu_ShowModalConfirmacion(false))

  return (
    <ModalBase
      Styles={{minWidth: '25%', maxWidth: '550px', backgroundColor: '#f1f1f1', padding: '2%'}}
    >
      <div className='form-content centrar-horizontal'>
        <h4 className='h4-titles'>Confirmación de Contacto</h4>
        <div>
          Para poder crear su usuario necesitamos verificar sus datos. Seleccione un método de
          verificación para continuar.
        </div>
        <div className='m buttons-div'>
          <button
            type='submit'
            className='m button transparent w-inline-block'
            onClick={actions.gu_cu_EnviarCodigoEmail}
          >
            <img src={DarkMessageIcom} loading='lazy' alt='correo electrónico' />
            Correo electrónico
          </button>
          <button type='submit' className='m button transparent w-inline-block' onClick={cancelar}>
            Cancelar
          </button>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalConfirmacionContacto
